import { httpAction, googleauth_api, facebookauth_api, createorder_api, estimateprice_api, updateprofile_api, onlinepay_api, mastervalues_api, logout_api, orders_api, master_api, ratecard_api, getproductitems_api } from "./http";
import {getToken} from "../store";

//listAction
export const listAction = (type, name, api) =>{
    let token = getToken();
    let headers  = token ? {
        "Authorization": `Token ${token}`
    } : {};
    switch(type) {
        case "LOAD":
            return httpAction(name, {
                url: api,
                method: "get",
                headers
            })
        case "NEXT":
            return httpAction(name, {
                url: api,
                method: "get",
                headers
            })
        case "UNLOAD":
            return { 
                type: `${name}_CLEAR`
            }
        default:
            return { 
                type: `${name}_CLEAR`
            }
    }
}

//modal
export const openModal = (modalName, modalProps={}) => {
    return {
        type : "OPEN_MODAL",
        modalName, 
        modalProps
    }
}

export const closeModal = () => {
    return {
        type : "CLOSE_MODAL"
    }
}

//toast starts here
let toast_id = 1;

//add toast message
export const addToast = (text, success=true) => {
    return {
        type: "ADD_TOAST",
        payload: {
            text,
            id: toast_id++,
            success
        }
    }
}
//remove toast
export const removeToast = (id) => {
    return {
        type: "REMOVE_TOAST",
        id
    }
}
//toast ends here

//social login
export const socialLogin = (google, data) => {
    return httpAction("LOGIN", {
        url: google ? googleauth_api: facebookauth_api,
        method: "post",
        data,
        headers: {
            "Content-type": "application/json"
        }
    })
}

//retrieve master value
export const retrieveInsDon = () => { 
    return httpAction("INSDON", [
        {
            url: mastervalues_api + 4 + "/",
            type: "GET"
        },
        {
            url: mastervalues_api + 5 + "/",
            type: "GET"
        },
        {
            "url": getproductitems_api,
            "method": "GET",
        }
    ])
}

export const updateInsAmt = (payload) => {
    return {
        type: "UPDATE_INS_AMT",
        payload
    }
}

//update profile
export const updateProfile = (data) => {
    let token = getToken();
    return httpAction("UPDATE_PROFILE", {
        url: updateprofile_api,
        method: "post",
        headers: {
            "Authorization": `Token ${token}`
        },
        data,
        crossDomain: true,
        contentType: false,
        processData: true
    })
}


//pickupmarker update position
//pos: {latitude, longitude}
//drag  P: pickup marker dragged/placed D: drop marker dragged/placed false: default or no thing happend
export const pickPos = (pos, drag=false, address='') => {
    return {
        type: "PICKUP_LOC",
        pos,
        pickupChanged: true,
        drag,
        address
    }
}

export const dropPos = (pos, drag=false, address='') => {
    return {
        type: "DROP_LOC",
        pos,
        dropChanged: true,
        drag,
        address
    }
}

export const clearPickup = () => {
    return {
        type: "CLEAR_PICKUP"
    }
}

export const clearDrop = () => {
    return {
        type: "CLEAR_DROP"
    }
}

export const clearPos = () => {
    return {
        type: "CLEAR_LOC"
    }
}

//booking 
export const bookNow = (data) => {
    let token = getToken();
    return httpAction("CREATE_ORDER", {
        url: createorder_api,
        method: "post",
        headers: {
            "Authorization": `Token ${token}`
        },
        data,
        crossDomain: true,
        contentType: false,
        processData: true
    })
}

//book online
export const bookOnline = (data) => {
    let token = getToken();
    return httpAction("CREATE_ORDER", {
        url: onlinepay_api,
        method: "post",
        headers: {
            "Authorization": `Token ${token}`,
            "Content-type": "application/json"
        },
        data
    })
}

//clear order
export const clearOrder = () => {
    return {
        type: "CREATE_ORDER_CLEAR"
    }
}

//estimate price
export const estimatePrice = (data) => {
    return httpAction("ESTIMATE_PRICE", {
        url: estimateprice_api,
        method: "post",
        headers: {
            "Content-type": "application/json"
        },
        data,
    })
}


let id = 1;

//image preview
export const addImagePreview = (images=[]) => {
    return {
        type: "ADD_IMAGE_PREIVEW",
        images: images.map(image => {
            return {...image,  id: id++}
        }),
    }
}

export const removeImagePreview = (id) => {
    return {
        type: "REMOVE_IMAGE_PREIVEW",
        id
    }
}

export const clearImagePreview = () => {
    return {
        type: "CLEAR_IMAGE_PREIVEW"
    }
}

//orders direction
export const showOrderDirection = (endpoints) => {
    return {
        type: "SHOW_ORDER_DIRECTION",
        endpoints
    }
}

export const hideOrderDirection = () => {
    return {
        type: "HIDE_ORDER_DIRECTION"
    }
}

//master values
export const getMasterValues = () => { 
    return httpAction("MASTER_VALUES", {
        url: mastervalues_api,
        type: "GET"
    })
}

// logout
export const logout = () => {
    let token = getToken();
    return httpAction("LOGOUT", {
        url: logout_api,
        method: "POST",
        headers: {
            "Authorization": `Token ${token}`,
        }
    })
}

// order pay online
export const orderPayOnline = (id) => {
    let token = getToken();
    return httpAction("ORDER_PAY_ONLINE", {
        url: orders_api + id + "/pay_online/",
        method: "GET",
        headers: {
            "Authorization": `Token ${token}`,
        }
    })
}

export const clearPayOnline = () => {
    return {
        type: "ORDER_PAY_ONLINE_CLEAR"
    }
}

// update paid status
export const updatePayStatus = (id, paid) => {
    return {
        type: "ORDERLIST_UPCOMING_UPDATE_PAID",
        id, paid
    }
}

//get master data
export const getMasterContent = (id) => {
    return httpAction("GET_MASTER", {
        method: "GET",
        url: master_api + id + "/"
    })
}

export const getMasterContentClear = () => ({
    type: "GET_MASTER_CLEAR"
})

export const getMasterValue = (id) => {
    return httpAction("GET_MASTERVALUE", {
        method: "GET",
        url: mastervalues_api + id + "/"
    })
}

export const getMasterValueClear = () => ({
    type: "GET_MASTERVALUE_CLEAR"
})

export const getRateCard = (data) => {
    return httpAction("GET_RATE_CARD", {
        method: "POST",
        url: ratecard_api,
        data,
        headers: {
            "Content-type": "application/json"
        }
    })
}

export const getRateCardClear = (data) => ({
    type: "GET_RATE_CARD_CLEAR"
})

export const getTeam = () => {
    return httpAction("OUR_TEAM", {
        url: "master/our-team/",
        method: "GET"
    })
}

export const applyCoupon = (payload) => {
    return dispatch => {
        dispatch(closeModal());
        dispatch({
            type: "APPLY_COUPON",
            payload
        })
    }
}

export const clearCoupon = () => {
    return {
        type : "CLEAR_COUPON"
    }
}
